import {
  Box,
  CssBaseline,
  ThemeProvider,
  createTheme,
  useMediaQuery,
  type PaletteMode,
} from "@mui/material";
import {  useMemo, useState } from "react";
import Editor from "./Editor";
import './EditorComponent2.css';

type EditorComponentProps = {
  content: string;
  onContentChange: (content: string) => void;
};

const EditorComponent: React.FC<EditorComponentProps> = ({ content, onContentChange }) => {
  const systemSettingsPrefersDarkMode = useMediaQuery(
    "(prefers-color-scheme: dark)"
  );
  const [paletteMode] = useState<PaletteMode>(
    systemSettingsPrefersDarkMode ? "dark" : "light"
  );
  /*
  const togglePaletteMode = useCallback(
    () =>
      setPaletteMode((prevMode) => (prevMode === "light" ? "dark" : "light")),
    []
  );
  */
  const theme = useMemo(
    () =>
      createTheme({
        components: {
          MuiPopper: {
            styleOverrides: {
              root: {
                // a fix for the tiptap links inside a modal
                zIndex: "1400 !important"
              }
            }
          }
        },
        palette: {
          mode: paletteMode,
          secondary: {
            main: "#42B81A",
          },
        },
      }),
    [paletteMode]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ p: 3, maxWidth: 1207, margin: "0 auto" }}>
        <Editor content={content} onContentChange={onContentChange} />
      </Box>
    </ThemeProvider>
  );
}

export default EditorComponent;
